/*
 * @Author: wangbaihe
 * @Date: 2025-10-31 19:23:15
 * @LastEditors: wangbaihe
 * @LastEditTime: 2025-11-03 13:53:38
 * @FilePath: \common-mediax\src\common\whitelist.js
 * @Description: 
 */
/**
* @Author: zhangxiaojian
* @Date: 2025/7/29
* @LastEditors: zhangxiaojian
* @Description 白名单配置
**/

export default {
  routeWhiteLimit:[
    // 切换租户时传递参数
    "checkSumRemoteMediax",
    // PUGC登录页面传递的参数
    "siteId",
    // AI魔方创建文章跳转到草稿箱
    "sign",
    // 第三方登录参数
    "al",
    "fl",
    "isCas",
    "ticket",
    "checkSum",
    // 腾讯云剪辑跳转回云雀登录页面
    "redirect_uri",
    "linkUrl", // 内容快运外部稿件地址链接
    "linkurl", // 内容快运外部稿件地址链接
  ]
}

